// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://use.typekit.net/aob3jjz.css);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /*
    Colors 🦋🌹🌈🔥

    This section is the canonical palette of colors. As a general rule, developers should attempt to choose an
    appropriate color from this palette. If an appropriate color is not part of the palette, the palette may be
    modified tastefully.

    Once an appropriate color is chosen from the palette, the developer may wish to create a Color Application variable.
    This allows us to decouple what the palette _is_ from how the palette is _used_. So, for example, if a new toolbar
    is being created, the developer might want to set \`--toolbar-background: var(--neutral-3)\` and then use
    \`var(--toolbar-background)\` in the relevant spot. That way, any changes to \`--neutral-3\` will be propagated to
    \`--toolbar-background\`, but we can change the \`--toolbar-background\` color without messing with other things
    that use \`--neutral-3\`.
  */

  /* Palette 🎨 - Brand */

  --fybr-blue: #2a8fed;
  --fybr-blue-translucent: rgba(46, 141, 204, 0.5);
  --fybr-slate: #4a4a4a;

  /* Palette 🎨 - Backgrounds */

  --alice: #f0f7fd;
  --mondrian: #06679e;
  --navy: #125482;
  --nocturn: #083a5d;
  --abyss: #0a253f;

  --twilight: #162028;
  --midnight: #020c13;

  --background-gradient: linear-gradient(var(--twilight), var(--midnight));
  --background-gradient-180: linear-gradient(var(--midnight), var(--twilight));

  /* Palette 🎨 - Interactions */

  --active-orange: rgba(255, 140, 20, 1);
  --dodger: #0087ff;
  --river: #44afee;
  --glacial: #00fcef;
  --electra: #00eee8;
  --interaction-gradient: linear-gradient(90deg, var(--dodger), var(--electra));

  --primary: var(--fybr-blue);
  --success: #0f9960;
  --danger: #d54746;
  --warning: #fbb360;

  /* Palette 🎨 - Neutrals */

  --neutral-1: #fafafa;
  --neutral-2: #f0f2f6;
  --neutral-3: #d3d6dd;
  --neutral-4: #95999e;
  --neutral-5: #64686c;
  --neutral-6: #272829;
  --neutral-7: #101112;

  --neutral-6-translucent: rgba(39, 40, 41, 0.6);

  /* Color Applications 🖍 */

  /* Based on canonical Alice Blue */
  --button-alice-active: hsl(208, 90%, 80%);
  --button-alice-normal: hsl(208, 76%, 97%);
  --button-alice-muted: hsl(208, 10%, 75%);

  --background-blue: var(--alice);
  --background-dark: var(--neutral-6);
  --background-dark-translucent: rgba(34, 34, 34, 0.8);
  --background-medium: var(--fybr-slate);
  --background-light: var(--neutral-1);

  --text-white: var(--neutral-2);

  --switch-thumb-inactive: var(--neutral-2);
  --switch-track-inactive: var(--neutral-3);

  --switch-thumb-active: var(--fybr-slate);
  --switch-track-active: var(--neutral-4);

  --disabled-gray: var(--neutral-5);

  --box-shadow: var(--neutral-6-translucent);

  /*
    Z Layering
    z-indices should, ideally, use a named layer level, in the form of one of the following variables.
    These apply to topmost layout components which have inherent overlapping behaviors;
    For other layering, source order is preferred, but there is plenty of wiggle room to do
    explicit z-index layering between the numbers. If that's _still_ not enough, shucks, add a 0.

    Don't try too hard to duck punch UI elements into these categories-- Create new ones or rename them instead.
    These names are ad hoc-- They can and should change to better reflect the design system as the app evolves.
  */

  --z-back: 0; /* e.g. Where the map is */
  --z-content: 100; /* e.g. Where the center pane is */
  --z-slideover: 200; /* e.g. Left pane, right pane */
  --z-overlay: 300; /* e.g. Modals, popups, toast notifications: These are supposed to go over top of everything except the header. */
  --z-header: 400;

  /* Secondary Z-layering */

  --z-header-main: 410;
  --z-header-subheader: 400;

  --button-border-radius: 2px;

  /* Secondary Z-layers */

  --z-back-overlay: calc(
    var(--z-back) + 10
  ); /* For the map HUD and other elements that should render on top of the map, and underneath everything else */

  /* Important Dimensions */

  --pane-width: minmax(15%, 340px);
  --left-pane-width: var(--pane-width);
  --right-pane-width: var(--pane-width);
}

a:focus,
div:focus,
span:focus,
input:focus,
input:checked,
button:focus,
select:focus {
  outline: none !important;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: "Inter", Helvetica, sans-serif;
  font-style: normal;
  line-height: normal;
  cursor: default;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Inter", Helvetica, sans-serif;
  font-weight: 700;
  margin: 0;
  padding: 0;
}

html p {
  margin-bottom: 0; /* Blueprint override */
}

p,
a.ui-link {
  position: relative;
}

strong {
  font-weight: 600;
}

html,
body {
  height: 100vh;
}

div#root {
  height: 100%;
}

a.ui-link {
  color: inherit;
  outline: none;
  text-decoration: none;
}

a.ui-link:hover {
  text-decoration: none;
  color: inherit;
}

/* Keep Blueprint portals above app chrome (--z-header-main: 410 is the max app
   layer). Equal z-index on sibling portals means paint order follows DOM order —
   later-opened overlays stack on top. Avoid nth-of-type ladders: Blueprint keeps
   closed portal divs in document.body while their hosts stay mounted, so busy
   orgs can exceed any fixed cap and later dialogs render behind the admin drawer. */

.bp6-portal {
  z-index: 10000;
}

.bp6-menu-item {
  align-items: center;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.support-overlay {
  left: calc(50vw - 300px);
  margin: 10vh 0;

  top: 0;
  width: 600px;
}

.order-overlay {
  left: calc(50vw - 200px);
  margin: 20vh 0;

  top: 0;
  width: 400px;
}

.upload-tooltip .bp6-tooltip .bp6-popover-content {
  background-color: var(--neutral-6);
  border: 1px solid var(--neutral-7);
  padding: 0;
}

.upload-tooltip .bp6-tooltip .bp6-popover-arrow-fill {
  fill: var(--neutral-6);
}

.upload-tooltip .bp6-tooltip .bp6-popover-arrow-border {
  fill: var(--neutral-7);
}

.tiptap-editor a {
  color: var(--fybr-blue);
}

.tiptap-editor p {
  margin: 0.75rem 0;
}

.tiptap-editor h1,
.tiptap-editor h2,
.tiptap-editor h3 {
  margin-top: 1rem;
  margin-bottom: 0.75rem;
}

.tiptap-editor ul,
.tiptap-editor ol {
  padding-left: 1.5rem;
}

.tiptap-editor em {
  font-style: italic;
}

.tiptap-editor video,
.tiptap-editor img {
  max-width: 100%;
  height: auto;
}

.tiptap-editor[contenteditable="true"] video.ProseMirror-selectednode,
.tiptap-editor[contenteditable="true"] img.ProseMirror-selectednode {
  outline: 4px solid var(--fybr-blue);
  outline-offset: -4px;
}

.tiptap-editor .kb-media-wrapper {
  position: relative;
  display: inline-block;
  max-width: 100%;
}

.tiptap-editor .kb-media-wrapper--image,
.tiptap-editor .kb-media-wrapper--video {
  border: 2px solid transparent;
  border-radius: 6px;
  overflow: hidden;
}

.tiptap-editor .kb-media-wrapper[data-upload-error] {
  border-color: #c23030;
  background: rgba(194, 48, 48, 0.06);
  min-height: 120px;
}

.kb-media-wrapper--image img,
.kb-media-wrapper--video video {
  max-width: 100%;
  height: auto;
  display: block;
}

.kb-video-uploading {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
  min-height: 180px;
  background: var(--neutral-2);
  border: 2px dashed var(--neutral-3);
  border-radius: 6px;
  padding: 1rem;
  width: 100%;
}

.kb-video-uploading__label {
  margin-bottom: 0.5rem;
  text-align: center;
  color: var(--neutral-6);
  font-weight: 600;
}

.kb-video-uploading__bar {
  width: 100%;
  height: 12px;
  background: var(--neutral-3);
  border-radius: 6px;
  overflow: hidden;
}

.kb-video-uploading__bar-fill {
  height: 100%;
  background: var(--fybr-blue);
  transition: width 0.2s ease;
}

.kb-video-uploading__text {
  margin-top: 0.5rem;
  text-align: center;
  color: var(--neutral-6);
  font-weight: 600;
  font-size: 0.95rem;
}

.kb-media-error {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(194, 48, 48, 0.9);
  color: #fff;
  font-size: 0.85rem;
  line-height: 1.3;
  padding: 6px 10px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.tiptap-editor[contenteditable="true"] .kb-media-wrapper[data-upload-error] {
  outline: 4px solid rgba(194, 48, 48, 0.35);
  outline-offset: -4px;
}

.kb-editor-toolbar {
  border: 1px solid #d8e1e8;
  background: #f5f8fa;
  border-radius: 8px;
  padding: 0.5rem 0.75rem;
  margin-bottom: 1rem;
}

.kb-editor-toolbar__row {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  align-items: center;
}

.annotation-handle-tooltip .mapboxgl-popup-content {
  background-color: var(--neutral-6);
  padding: 6px 10px;
  font-size: 12px;
}
.annotation-handle-tooltip.mapboxgl-popup-anchor-top .mapboxgl-popup-tip,
.annotation-handle-tooltip.mapboxgl-popup-anchor-top-left .mapboxgl-popup-tip,
.annotation-handle-tooltip.mapboxgl-popup-anchor-top-right .mapboxgl-popup-tip {
  border-bottom-color: var(--neutral-6);
}
.annotation-handle-tooltip.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip,
.annotation-handle-tooltip.mapboxgl-popup-anchor-bottom-left .mapboxgl-popup-tip,
.annotation-handle-tooltip.mapboxgl-popup-anchor-bottom-right .mapboxgl-popup-tip {
  border-top-color: var(--neutral-6);
}
.annotation-handle-tooltip.mapboxgl-popup-anchor-left .mapboxgl-popup-tip {
  border-right-color: var(--neutral-6);
}
.annotation-handle-tooltip.mapboxgl-popup-anchor-right .mapboxgl-popup-tip {
  border-left-color: var(--neutral-6);
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAGA;EACE;;;;;;;;;;;;;GAaC;;EAED,uBAAuB;;EAEvB,oBAAoB;EACpB,gDAAgD;EAChD,qBAAqB;;EAErB,6BAA6B;;EAE7B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;;EAEhB,mBAAmB;EACnB,mBAAmB;;EAEnB,wEAAwE;EACxE,4EAA4E;;EAE5E,8BAA8B;;EAE9B,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,6EAA6E;;EAE7E,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;;EAElB,0BAA0B;;EAE1B,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,8CAA8C;;EAE9C,0BAA0B;;EAE1B,kCAAkC;EAClC,yCAAyC;EACzC,yCAAyC;EACzC,wCAAwC;;EAExC,+BAA+B;EAC/B,mCAAmC;EACnC,oDAAoD;EACpD,sCAAsC;EACtC,oCAAoC;;EAEpC,8BAA8B;;EAE9B,yCAAyC;EACzC,yCAAyC;;EAEzC,wCAAwC;EACxC,uCAAuC;;EAEvC,iCAAiC;;EAEjC,0CAA0C;;EAE1C;;;;;;;;;GASC;;EAED,WAAW,EAAE,0BAA0B;EACvC,gBAAgB,EAAE,kCAAkC;EACpD,kBAAkB,EAAE,+BAA+B;EACnD,gBAAgB,EAAE,iHAAiH;EACnI,eAAe;;EAEf,yBAAyB;;EAEzB,oBAAoB;EACpB,yBAAyB;;EAEzB,2BAA2B;;EAE3B,uBAAuB;;EAEvB;;GAEC,EAAE,4GAA4G;;EAE/G,yBAAyB;;EAEzB,gCAAgC;EAChC,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;;;;;;;EAOE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,2CAA2C;EAC3C,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;;;;EAME,2CAA2C;EAC3C,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB,EAAE,uBAAuB;AAC3C;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;;oFAIoF;;AAEpF;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,cAAc;;EAEd,MAAM;EACN,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,cAAc;;EAEd,MAAM;EACN,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;EAGE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,4BAA4B;EAC5B,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,iBAAiB;EACjB,eAAe;AACjB;AACA;;;EAGE,qCAAqC;AACvC;AACA;;;EAGE,kCAAkC;AACpC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,mCAAmC;AACrC","sourcesContent":["@import url(\"https://use.typekit.net/aob3jjz.css\");\n@import url(\"https://fonts.googleapis.com/css2?family=Roboto:wght@700&display=swap\");\n\n:root {\n  /*\n    Colors 🦋🌹🌈🔥\n\n    This section is the canonical palette of colors. As a general rule, developers should attempt to choose an\n    appropriate color from this palette. If an appropriate color is not part of the palette, the palette may be\n    modified tastefully.\n\n    Once an appropriate color is chosen from the palette, the developer may wish to create a Color Application variable.\n    This allows us to decouple what the palette _is_ from how the palette is _used_. So, for example, if a new toolbar\n    is being created, the developer might want to set `--toolbar-background: var(--neutral-3)` and then use\n    `var(--toolbar-background)` in the relevant spot. That way, any changes to `--neutral-3` will be propagated to\n    `--toolbar-background`, but we can change the `--toolbar-background` color without messing with other things\n    that use `--neutral-3`.\n  */\n\n  /* Palette 🎨 - Brand */\n\n  --fybr-blue: #2a8fed;\n  --fybr-blue-translucent: rgba(46, 141, 204, 0.5);\n  --fybr-slate: #4a4a4a;\n\n  /* Palette 🎨 - Backgrounds */\n\n  --alice: #f0f7fd;\n  --mondrian: #06679e;\n  --navy: #125482;\n  --nocturn: #083a5d;\n  --abyss: #0a253f;\n\n  --twilight: #162028;\n  --midnight: #020c13;\n\n  --background-gradient: linear-gradient(var(--twilight), var(--midnight));\n  --background-gradient-180: linear-gradient(var(--midnight), var(--twilight));\n\n  /* Palette 🎨 - Interactions */\n\n  --active-orange: rgba(255, 140, 20, 1);\n  --dodger: #0087ff;\n  --river: #44afee;\n  --glacial: #00fcef;\n  --electra: #00eee8;\n  --interaction-gradient: linear-gradient(90deg, var(--dodger), var(--electra));\n\n  --primary: var(--fybr-blue);\n  --success: #0f9960;\n  --danger: #d54746;\n  --warning: #fbb360;\n\n  /* Palette 🎨 - Neutrals */\n\n  --neutral-1: #fafafa;\n  --neutral-2: #f0f2f6;\n  --neutral-3: #d3d6dd;\n  --neutral-4: #95999e;\n  --neutral-5: #64686c;\n  --neutral-6: #272829;\n  --neutral-7: #101112;\n\n  --neutral-6-translucent: rgba(39, 40, 41, 0.6);\n\n  /* Color Applications 🖍 */\n\n  /* Based on canonical Alice Blue */\n  --button-alice-active: hsl(208, 90%, 80%);\n  --button-alice-normal: hsl(208, 76%, 97%);\n  --button-alice-muted: hsl(208, 10%, 75%);\n\n  --background-blue: var(--alice);\n  --background-dark: var(--neutral-6);\n  --background-dark-translucent: rgba(34, 34, 34, 0.8);\n  --background-medium: var(--fybr-slate);\n  --background-light: var(--neutral-1);\n\n  --text-white: var(--neutral-2);\n\n  --switch-thumb-inactive: var(--neutral-2);\n  --switch-track-inactive: var(--neutral-3);\n\n  --switch-thumb-active: var(--fybr-slate);\n  --switch-track-active: var(--neutral-4);\n\n  --disabled-gray: var(--neutral-5);\n\n  --box-shadow: var(--neutral-6-translucent);\n\n  /*\n    Z Layering\n    z-indices should, ideally, use a named layer level, in the form of one of the following variables.\n    These apply to topmost layout components which have inherent overlapping behaviors;\n    For other layering, source order is preferred, but there is plenty of wiggle room to do\n    explicit z-index layering between the numbers. If that's _still_ not enough, shucks, add a 0.\n\n    Don't try too hard to duck punch UI elements into these categories-- Create new ones or rename them instead.\n    These names are ad hoc-- They can and should change to better reflect the design system as the app evolves.\n  */\n\n  --z-back: 0; /* e.g. Where the map is */\n  --z-content: 100; /* e.g. Where the center pane is */\n  --z-slideover: 200; /* e.g. Left pane, right pane */\n  --z-overlay: 300; /* e.g. Modals, popups, toast notifications: These are supposed to go over top of everything except the header. */\n  --z-header: 400;\n\n  /* Secondary Z-layering */\n\n  --z-header-main: 410;\n  --z-header-subheader: 400;\n\n  --button-border-radius: 2px;\n\n  /* Secondary Z-layers */\n\n  --z-back-overlay: calc(\n    var(--z-back) + 10\n  ); /* For the map HUD and other elements that should render on top of the map, and underneath everything else */\n\n  /* Important Dimensions */\n\n  --pane-width: minmax(15%, 340px);\n  --left-pane-width: var(--pane-width);\n  --right-pane-width: var(--pane-width);\n}\n\na:focus,\ndiv:focus,\nspan:focus,\ninput:focus,\ninput:checked,\nbutton:focus,\nselect:focus {\n  outline: none !important;\n}\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  font-family: \"Inter\", Helvetica, sans-serif;\n  font-style: normal;\n  line-height: normal;\n  cursor: default;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Inter\", Helvetica, sans-serif;\n  font-weight: 700;\n  margin: 0;\n  padding: 0;\n}\n\nhtml p {\n  margin-bottom: 0; /* Blueprint override */\n}\n\np,\na.ui-link {\n  position: relative;\n}\n\nstrong {\n  font-weight: 600;\n}\n\nhtml,\nbody {\n  height: 100vh;\n}\n\ndiv#root {\n  height: 100%;\n}\n\na.ui-link {\n  color: inherit;\n  outline: none;\n  text-decoration: none;\n}\n\na.ui-link:hover {\n  text-decoration: none;\n  color: inherit;\n}\n\n/* Keep Blueprint portals above app chrome (--z-header-main: 410 is the max app\n   layer). Equal z-index on sibling portals means paint order follows DOM order —\n   later-opened overlays stack on top. Avoid nth-of-type ladders: Blueprint keeps\n   closed portal divs in document.body while their hosts stay mounted, so busy\n   orgs can exceed any fixed cap and later dialogs render behind the admin drawer. */\n\n.bp6-portal {\n  z-index: 10000;\n}\n\n.bp6-menu-item {\n  align-items: center;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.support-overlay {\n  left: calc(50vw - 300px);\n  margin: 10vh 0;\n\n  top: 0;\n  width: 600px;\n}\n\n.order-overlay {\n  left: calc(50vw - 200px);\n  margin: 20vh 0;\n\n  top: 0;\n  width: 400px;\n}\n\n.upload-tooltip .bp6-tooltip .bp6-popover-content {\n  background-color: var(--neutral-6);\n  border: 1px solid var(--neutral-7);\n  padding: 0;\n}\n\n.upload-tooltip .bp6-tooltip .bp6-popover-arrow-fill {\n  fill: var(--neutral-6);\n}\n\n.upload-tooltip .bp6-tooltip .bp6-popover-arrow-border {\n  fill: var(--neutral-7);\n}\n\n.tiptap-editor a {\n  color: var(--fybr-blue);\n}\n\n.tiptap-editor p {\n  margin: 0.75rem 0;\n}\n\n.tiptap-editor h1,\n.tiptap-editor h2,\n.tiptap-editor h3 {\n  margin-top: 1rem;\n  margin-bottom: 0.75rem;\n}\n\n.tiptap-editor ul,\n.tiptap-editor ol {\n  padding-left: 1.5rem;\n}\n\n.tiptap-editor em {\n  font-style: italic;\n}\n\n.tiptap-editor video,\n.tiptap-editor img {\n  max-width: 100%;\n  height: auto;\n}\n\n.tiptap-editor[contenteditable=\"true\"] video.ProseMirror-selectednode,\n.tiptap-editor[contenteditable=\"true\"] img.ProseMirror-selectednode {\n  outline: 4px solid var(--fybr-blue);\n  outline-offset: -4px;\n}\n\n.tiptap-editor .kb-media-wrapper {\n  position: relative;\n  display: inline-block;\n  max-width: 100%;\n}\n\n.tiptap-editor .kb-media-wrapper--image,\n.tiptap-editor .kb-media-wrapper--video {\n  border: 2px solid transparent;\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.tiptap-editor .kb-media-wrapper[data-upload-error] {\n  border-color: #c23030;\n  background: rgba(194, 48, 48, 0.06);\n  min-height: 120px;\n}\n\n.kb-media-wrapper--image img,\n.kb-media-wrapper--video video {\n  max-width: 100%;\n  height: auto;\n  display: block;\n}\n\n.kb-video-uploading {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  align-items: center;\n  justify-content: center;\n  min-height: 180px;\n  background: var(--neutral-2);\n  border: 2px dashed var(--neutral-3);\n  border-radius: 6px;\n  padding: 1rem;\n  width: 100%;\n}\n\n.kb-video-uploading__label {\n  margin-bottom: 0.5rem;\n  text-align: center;\n  color: var(--neutral-6);\n  font-weight: 600;\n}\n\n.kb-video-uploading__bar {\n  width: 100%;\n  height: 12px;\n  background: var(--neutral-3);\n  border-radius: 6px;\n  overflow: hidden;\n}\n\n.kb-video-uploading__bar-fill {\n  height: 100%;\n  background: var(--fybr-blue);\n  transition: width 0.2s ease;\n}\n\n.kb-video-uploading__text {\n  margin-top: 0.5rem;\n  text-align: center;\n  color: var(--neutral-6);\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.kb-media-error {\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(194, 48, 48, 0.9);\n  color: #fff;\n  font-size: 0.85rem;\n  line-height: 1.3;\n  padding: 6px 10px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.tiptap-editor[contenteditable=\"true\"] .kb-media-wrapper[data-upload-error] {\n  outline: 4px solid rgba(194, 48, 48, 0.35);\n  outline-offset: -4px;\n}\n\n.kb-editor-toolbar {\n  border: 1px solid #d8e1e8;\n  background: #f5f8fa;\n  border-radius: 8px;\n  padding: 0.5rem 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.kb-editor-toolbar__row {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  align-items: center;\n}\n\n.annotation-handle-tooltip .mapboxgl-popup-content {\n  background-color: var(--neutral-6);\n  padding: 6px 10px;\n  font-size: 12px;\n}\n.annotation-handle-tooltip.mapboxgl-popup-anchor-top .mapboxgl-popup-tip,\n.annotation-handle-tooltip.mapboxgl-popup-anchor-top-left .mapboxgl-popup-tip,\n.annotation-handle-tooltip.mapboxgl-popup-anchor-top-right .mapboxgl-popup-tip {\n  border-bottom-color: var(--neutral-6);\n}\n.annotation-handle-tooltip.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip,\n.annotation-handle-tooltip.mapboxgl-popup-anchor-bottom-left .mapboxgl-popup-tip,\n.annotation-handle-tooltip.mapboxgl-popup-anchor-bottom-right .mapboxgl-popup-tip {\n  border-top-color: var(--neutral-6);\n}\n.annotation-handle-tooltip.mapboxgl-popup-anchor-left .mapboxgl-popup-tip {\n  border-right-color: var(--neutral-6);\n}\n.annotation-handle-tooltip.mapboxgl-popup-anchor-right .mapboxgl-popup-tip {\n  border-left-color: var(--neutral-6);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
